// components/school/CultureImages.jsx
"use client";

import img1 from "@/assets/culture/01.jpg";
import img2 from "@/assets/culture/02.jpg";
import img3 from "@/assets/culture/03.jpg";
import img4 from "@/assets/culture/04.jpg";
import img6 from "@/assets/culture/06.jpg";
import img8 from "@/assets/culture/08.jpg";
import img9 from "@/assets/culture/09.jpg";
import large1 from "@/assets/culture/large-1.jpg";
import large2 from "@/assets/culture/large-2.jpg";
import ImageLightboxGrid from "@/ui/ImageLightBoxgrid";


const cultureItems = [
    { src: img1, alt: "Campus culture 1" },
    { src: img2, alt: "Campus culture 2" },
    { src: img3, alt: "Campus culture 3" },
    { src: img4, alt: "Campus culture 4" },
    { src: img6, alt: "Campus culture 6" },
    { src: img8, alt: "Campus culture 8" },
    { src: img9, alt: "Campus culture 9" },
    { src: large1, alt: "Campus culture large 1" },
    { src: large2, alt: "Campus culture large 2" },
];

const CultureImages = () => {
    return <ImageLightboxGrid items={cultureItems} title="" />;
};

export default CultureImages;
